export const config = {
  apiKey: 'AIzaSyCZtlAJo6dxv4MW6ep_xV0VTBfDq0VJEFo',
  authDomain: 'noahs-ark-prototype.firebaseapp.com',
  projectId: 'noahs-ark-prototype',
  storageBucket: 'noahs-ark-prototype.appspot.com',
  messagingSenderId: '386411183991',
  appId: '1:386411183991:web:d9c0fdfe3deb36c3242b72',
  measurementId: 'G-02GV9FMM8P'
}
